export enum DatadogAdsEvents {
  Impression = 'ads-impressions',
  Mounted = 'ads-renders',
  RequestedImpression = 'ads-requested-log-impressions',
}

export enum DatadogVideoEvents {
  PlaybackStart = 'listings-webapp.event_video_playback_start',
  PlaybackFailed = 'listings-webapp.event_video_playback_failed',
  PlaybackEnd = 'listings-webapp.event_video_playback_end',
}
